import { Fragment } from 'react';
import { Link } from '@hc/redux-saga-router-plus';
import { Dialog } from 'legacy/components/Dialog';
import ChartButton from 'legacy/components/ChartButton';
import GlossaryButton from 'legacy/components/GlossaryButton';

import NearbyPropertiesSectionContainer from 'legacy/containers/nearby-properties-section';

import { PropertyExplorerCharts as chartTheme } from 'legacy/css-modules';

const PropertyExplorerNearbyChartButton = ({
  chartModal,
  onClick,
  chartType,
  onClose,
  onClickInfoButton
}) => {
  return (
    <Fragment>
      <Link
        options={{ inherit: true }}
        query={{ chartModal: 'nearbyChart' }}
        className={chartTheme.LinkButton}
        onClick={onClick}
      >
        <ChartButton title={'Nearby Properties'}>
          <div className={chartTheme.ChartButtonText}>
            See how this property matches up against other properties close by.
          </div>
        </ChartButton>
      </Link>
      <Dialog
        className={chartTheme.NearbyChartDialog}
        theme={chartTheme}
        active={chartModal === 'nearbyChart'}
        title={
          <div className={chartTheme.DialogHeader}>
            {chartType === 'nearby'
              ? 'Nearby Properties'
              : 'Comparable Properties'}
            {chartType === 'nearby' && (
              <GlossaryButton
                height="16px"
                width="16px"
                className={chartTheme.Icon}
                onClick={() => onClickInfoButton()}
              />
            )}
          </div>
        }
        onClose={onClose}
        closeButton
      >
        <NearbyPropertiesSectionContainer />
      </Dialog>
    </Fragment>
  );
};

export default PropertyExplorerNearbyChartButton;
